import { render, staticRenderFns } from "./InitiativeForm.vue?vue&type=template&id=3effc140&"
import script from "./InitiativeForm.vue?vue&type=script&lang=js&"
export * from "./InitiativeForm.vue?vue&type=script&lang=js&"
import style0 from "./InitiativeForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports